// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const RCAPengajuanApprovalService = {};

RCAPengajuanApprovalService.getRCAPengajuanApprovalService = function (data) {
  const dataIndex = data.pageIndex || 0;
  const decrementIndex = dataIndex === 0 ? 0 : dataIndex - 1;

  const params = new URLSearchParams({
    pageSize: data.pageSize || 10,
    pageIndex: decrementIndex,
    customername: data.customername || "",
    facilityid: data.facilityid || "",
    approvalType: data.approvalType || "",
  });

  return lossClient({
    url: `/RCAPengajuanApproval/search?${params.toString()}`,
    method: "get",
  });
};

RCAPengajuanApprovalService.approverDropdownService = function (data) {
  const dataIndex = data.pageIndex || 0;
  const decrementIndex = dataIndex === 0 ? 0 : dataIndex - 1;

  const params = new URLSearchParams({
    pageSize: data.pageSize || 10,
    pageIndex: decrementIndex,
    facilityid: data.facilityid || "",
  });

  return lossClient({
    url: `/RCAPengajuanApproval/approver-dropdown?${params.toString()}`,
    method: "get",
  });
};

RCAPengajuanApprovalService.saveRCAApprovalService = function (data) {
  return lossClient({
    url: `/RCAPengajuanApproval/add`,
    method: "post",
    headers: {},
    data: data,
  });
};

RCAPengajuanApprovalService.searchApprovalStatusService = function (data) {
  const dataIndex = data.pageIndex || 0;
  const decrementIndex = dataIndex === 0 ? 0 : dataIndex - 1;

  const params = new URLSearchParams({
    pageSize: data.pageSize || 10,
    pageIndex: decrementIndex,
    searchParam: data.searchParam || "",
    customerName: data.customerName || "",
    facilityid: data.facilityid || "",
    approvalNo: data.approvalNo || "",
    approvalId: data.approvalId || "",
    branchId: data.branchId || "",
    approvalstatus: data.approvalstatus || "",
    approvalstep: data.approvalstep || "",
    requestBy: data.requestBy || "",
    willBeApprovedBy: data.willBeApprovedBy || "",
  });

  return lossClient({
    url: `/RCAPengajuanApproval/searchApprovalStatus?${params.toString()}`,
    method: "get",
  });
};

RCAPengajuanApprovalService.searchApprovalDetailService = function (data) {
  const dataIndex = data.pageIndex || 0;
  const decrementIndex = dataIndex === 0 ? 0 : dataIndex - 1;

  const params = new URLSearchParams({
    pageSize: data.pageSize || 10,
    pageIndex: decrementIndex,
    facilityid: data.facilityid || "",
    approvalNo: data.approvalNo || "",
  });

  return lossClient({
    url: `/RCAPengajuanApproval/searchApprovalDetail?${params.toString()}`,
    method: "get",
  });
};

RCAPengajuanApprovalService.getApproverLimitService = function (data) {
  const dataIndex = data.pageIndex || 0;
  const decrementIndex = dataIndex === 0 ? 0 : dataIndex - 1;

  const params = new URLSearchParams({
    pageSize: data.pageSize || 10,
    pageIndex: decrementIndex,
    facilityid: data.facilityid || "",
    employeeId: data.employeeId || "",
  });

  return lossClient({
    url: `/RCAPengajuanApproval/get-approver-limit?${params.toString()}`,
    method: "get",
  });
};

RCAPengajuanApprovalService.saveApprovalDetailService = function (data) {
  return lossClient({
    url: `/ApprovalDetail/add`,
    method: "post",
    headers: {},
    data: data,
  });
};

// ------------------ Apk KKB ------------------

RCAPengajuanApprovalService.searchApprovalStatusKKBService = function (data) {
  const dataIndex = data.pageIndex || 0;
  const decrementIndex = dataIndex === 0 ? 0 : dataIndex - 1;
  

  const params = new URLSearchParams({
    pageSize: data.pageSize || 10,
    pageIndex: decrementIndex,
    searchParam: data.searchParam || "",
    customerName: data.customerName || "",
    facilityid: data.facilityid || "",
    approvalNo: data.approvalNo || "",
    approvalId: data.approvalId || "",
    branchId: data.branchId || "",
    approvalstatus: data.approvalstatus || "",
    approvalstep: data.approvalstep || "",
    requestBy: data.requestBy || "",
    willBeApprovedBy: data.willBeApprovedBy || "",
  });

  return lossClient({
    url: `/RCAPengajuanApprovalKKB/searchApprovalStatus?${params.toString()}`,
    method: "get",
  });
};

RCAPengajuanApprovalService.searchApprovalDetailKKBService = function (data) {
  const dataIndex = data.pageIndex || 0;
  const decrementIndex = dataIndex === 0 ? 0 : dataIndex - 1;

  const params = new URLSearchParams({
    pageSize: data.pageSize || 10,
    pageIndex: decrementIndex,
    facilityid: data.facilityid || "",
    approvalNo: data.approvalNo || "",
  });

  return lossClient({
    url: `/RCAPengajuanApprovalKKB/searchApprovalDetail?${params.toString()}`,
    method: "get",
  });
};

RCAPengajuanApprovalService.getApproverLimitKKBService = function (data) {
  const dataIndex = data.pageIndex || 0;
  const decrementIndex = dataIndex === 0 ? 0 : dataIndex - 1;

  const params = new URLSearchParams({
    pageSize: data.pageSize || 10,
    pageIndex: decrementIndex,
    applicationid: data.applicationid || "",
    employeeId: data.employeeId || "",
  });

  return lossClient({
    url: `/RCAPengajuanApprovalKKB/get-approver-limit?${params.toString()}`,
    method: "get",
  });
};

RCAPengajuanApprovalService.saveApprovalDetailKKBService = function (data) {
  return lossClient({
    url: `/ApprovalDetailLoan/add`,
    method: "post",
    headers: {},
    data: data,
  });
};

RCAPengajuanApprovalService.getSearchSppkListService = function (data) {
  const dataIndex = data.pageIndex || 0;
  const decrementIndex = dataIndex === 0 ? 0 : dataIndex - 1;

  const params = new URLSearchParams({
    pageSize: data.pageSize || 10,
    pageIndex: decrementIndex,
    name: data.name || "",
    applicationid: data.applicationid || "",
    startDate: data.startDate || "",
    endDate: data.endDate || "",
  });

  return lossClient({
    url: `/RCAPengajuanApprovalKKB/searchSppkList?${params.toString()}`,
    method: "get",
  });
};

RCAPengajuanApprovalService.getSearchSppkListService = function (data) {
  const dataIndex = data.pageIndex || 0;
  const decrementIndex = dataIndex === 0 ? 0 : dataIndex - 1;

  const params = new URLSearchParams({
    pageSize: data.pageSize || 10,
    pageIndex: decrementIndex,
    name: data.name || "",
    applicationid: data.applicationid || "",
    startDate: data.startDate || "",
    endDate: data.endDate || "",
  });

  return lossClient({
    url: `/RCAPengajuanApprovalKKB/searchSppkList?${params.toString()}`,
    method: "get",
  });
};

RCAPengajuanApprovalService.getSearchSppkReportService = async function (data) {
  const params = new URLSearchParams({
    applicationid: data?.applicationid || "",
  });
  try {
    // Ganti baseURL sesuai kebutuhan jika di dev/prod
    const baseURL = process.env.REACT_APP_API_URL || "http://192.168.2.171:8080/api/los";
    const url = `${baseURL}/JsReport/loan?${params.toString()}`;
    const response = await lossClient({
      url: url,
      method: "GET",
      headers: {
        // Tambahkan header jika diperlukan
      },
    });
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const blob = await response.blob();
    // Coba ambil nama file dari header jika ada
    let filename = "loan_report.pdf";
    const disposition = response.headers.get("content-disposition");
    if (disposition && disposition.indexOf("filename=") !== -1) {
      const match = disposition.match(/filename="?([^";]+)"?/);
      if (match && match[1]) filename = match[1];
    }
    const downloadUrl = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = downloadUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(downloadUrl);
  } catch (error) {
    console.error("Download failed:", error);
  }
};

export default RCAPengajuanApprovalService;
